module.exports = __webpack_public_path__ + "static/media/noclass15.65a1e95f.png";